import Layout from '@/layout';
var wechatOpenPlatformRouter = {
  path: '/wechatOpenPlatform',
  component: Layout,
  redirect: '/wechatOpenPlatform/index',
  name: 'wechatOpenPlatform',
  meta: {
    title: '微信服务商',
    icon: 'wechat'
  },
  children: [{
    path: 'index',
    name: 'wechatOpenPlatformIndex',
    component: function component() {
      return import('@/views/wechatOpenPlatform');
    },
    meta: {
      title: '服务商管理',
      icon: ''
    }
  }, {
    path: 'miniProgramVersion',
    name: 'wechatOpenPlatformMiniProgramVersion',
    component: function component() {
      return import('@/views/wechatOpenPlatform/miniProgramVersion');
    },
    meta: {
      title: '小程序版本管理',
      icon: ''
    }
  }]
};
export default wechatOpenPlatformRouter;